import { combineReducers } from "redux";
import { call, put, select, takeLatest, all } from 'redux-saga/effects';
import { reportsAPI } from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import { START } from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { modeReducer } from "./mode/modeReducer";



export const STUDENTS_INFO_REQUEST = "STUDENTS_INFO_REQUEST";
export const SET_FORM_DATA = "SET_STUDENTS_INFO_FORM_DATA";

export const studentsInfoReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
    mode: modeReducer,
});

//actions
export const studentsInfoActions = createActions('studentsInfo', STUDENTS_INFO_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload });

// SAGAS
export function* studentsInfoWatcher() {
    yield takeLatest(`${STUDENTS_INFO_REQUEST}${START}`, studentsInfoWorker)
}

const unwrap = (response) => {
    const answer = response?.data?.Answer
    // if (!answer || answer.Result !== 'Success') {
    //     const desc = answer?.Data_?.Error?.desc || 'Unknown API error'
    //     throw new Error(desc)
    // }
    const data = answer.Data_ || {}
    const rows = data.items || []
    return { academicYear: data.academicYear, rows }
}

function* studentsInfoWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.studentsInfo.form)
        const params = { ...auth, ...form }
        const isSchools = form.school === '2'
        const calls = isSchools
            ? [call(reportsAPI.studentsInfoSummary, params)]
            : [
                call(reportsAPI.studentsInfoSummary, params),
                call(reportsAPI.studentsInfoDischarged, params),
            ]
        const results = yield all(calls)
        const data = {
            summary: unwrap(results[0]),
            discharged: isSchools ? null : unwrap(results[1]),
            mode: isSchools ? 'schools' : 'mixed',
        }
        yield put(studentsInfoActions.studentsInfoRequestSuccess(data));
    } catch (error) {
        yield put(studentsInfoActions.studentsInfoRequestError(error));
    }
}
